/* eslint-disable react/prop-types */
import React from 'react';
import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

const shortDate = (d) => String(d).split('-').slice(1).reverse().join('/'); // DD/MM
const fmtHM = (minutes) => {
  const mins = Number(minutes) || 0;
  const h = Math.floor(mins / 60);
  const m = Math.round(mins % 60);
  return `${h}h ${m}m`;
};

const TooltipContent = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null;
  const mins = payload[0]?.payload?.minutes;
  return (
    <div style={{
      background: '#fff', color: '#1f2d3d', padding: '8px 12px', borderRadius: '10px',
      fontSize: '13px', border: '1px solid #e6edf2', boxShadow: '0 6px 18px rgba(31,45,61,0.10)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 4 }}>{`Date: ${String(label).split('-').reverse().join('/')}`}</div>
      <div>Sleep: <b>{fmtHM(mins)}</b></div>
    </div>
  );
};

// Sleep duration per day over the selected range. An area/line trend reads cleanly at
// any range (weeks or 6+ months), unlike per-day bars. Mirrors the portal's shared
// single-series trend aesthetic (coral). Date selection lives in the daily table.
const SleepDurationTrendChart = ({ data = [] }) => {
  // chartData arrives newest-first; the trend needs oldest→newest on the X axis.
  const series = [...data]
    .map((d) => ({ date: d.date, minutes: Number(d.total_sleep_minutes) || 0, hours: (Number(d.total_sleep_minutes) || 0) / 60 }))
    .sort((a, b) => (a.date < b.date ? -1 : 1));

  const enough = series.length >= 2;
  const single = series.length === 1;

  if (!enough) {
    return (
      <div className="au-chart-empty" data-testid="ss-duration-empty">
        {single
          ? `${fmtHM(series[0].minutes)} slept on ${shortDate(series[0].date)}.`
          : 'Not enough data to plot a trend (need at least 2 days).'}
      </div>
    );
  }

  return (
    <div data-testid="ss-duration-trend">
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={series} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
          <defs>
            <linearGradient id="ssDurFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#f26b45" stopOpacity={0.24} />
              <stop offset="100%" stopColor="#f26b45" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#eef2f1" vertical={false} />
          <XAxis dataKey="date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} minTickGap={24} />
          <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} tickFormatter={(v) => `${v}h`} />
          <Tooltip content={<TooltipContent />} cursor={{ stroke: '#f26b45', strokeOpacity: 0.3 }} />
          <Area type="monotone" dataKey="hours" name="Sleep duration" stroke="#f26b45" strokeWidth={2.5} fill="url(#ssDurFill)" dot={false} isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SleepDurationTrendChart;
